
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.64 3.846c.556-1.128 2.164-1.128 2.72 0l1.965 3.987 4.381.654c1.236.184 1.73 1.7.842 2.577l-3.17 3.13.737 4.405c.208 1.237-1.091 2.176-2.2 1.592L12 18.13l-3.915 2.06c-1.109.584-2.408-.355-2.2-1.592l.737-4.404-3.17-3.13c-.889-.878-.394-2.394.842-2.578l4.38-.654 1.966-3.987zm1.36.67L9.683 9.215l-5.166.77 3.73 3.684-.867 5.18L12 16.417l4.62 2.432-.867-5.18 3.73-3.683-5.166-.771L12 4.515z"}})])
          )
        }
      }
    